const resolveFieldLinkHref = (linkTemplate, value) => {
  const normalizedValue = typeof value === 'string' ? value.trim() : value

  if (!linkTemplate || !normalizedValue) return ''

  return linkTemplate.replace(/\{value\}/g, encodeURIComponent(normalizedValue))
}

export default resolveFieldLinkHref
